import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpManagerService}  from '../httpmanager.service';
import { identifierModuleUrl } from '@angular/compiler';



@Injectable()
export class BlogPostdetailsService {

    
    constructor(private httpmanagerService: HttpManagerService,
        ) {

    }

    
   
    
    allimage(data,id): Promise<any> {
        return this.httpmanagerService.HttpPost('blogimage/imagelist', JSON.stringify(data),id).then(data => {
            if (data) {
                return data.data;
            }
        });
    }

    Uploadimage(data,file ,id):Promise<any> {
        return this.httpmanagerService.HttpPostImageId('blogimage', JSON.stringify(data),file,id).then(data => {
           return data
        });
    }
    dblogimage(data,id): Promise<any> {
        return this.httpmanagerService.HttpPost('blogimage/deletepost',JSON.stringify(data), id).then(data => {
        
                return data
            
        });
    }
    iblogpost1(data,file ,id):Promise<any> {
        return this.httpmanagerService.HttpPostImageId('blogpostdetails/savedraft', JSON.stringify(data),file,id).then(data => {
           return data
        });
    }
    iblogpost(data,file ,id):Promise<any> {
        return this.httpmanagerService.HttpPostImageId('blogpostdetails', JSON.stringify(data),file,id).then(data => {
           return data
        });
    }
    Updateimage(data,id):Promise<any> {
        return this.httpmanagerService.HttpPut('blogimage',JSON.stringify(data), id).then(data => {
           return data
        });
    }
    Updatestatus(data,id):Promise<any> {
        return this.httpmanagerService.HttpPut('blogpostdetails',JSON.stringify(data), id).then(data => {
           return data
        });
    }
   
    Oldblog(Post): Promise<any> {
        return this.httpmanagerService.HttpGet('blogpost/blog', Post).then(data => {
            return data;
        })
    }
   
  
  
    
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/blogpostdetails/blogpostdetails.service.ts